import React from 'react';
import './App.css';
import RootPage from "./pages/RootPage";

function App() {
    return (
        <div className="App">
            <RootPage />
        </div>
    );
}

export default App;
